export function extractCatalogId(channel) {
  const configurations = channel?.configurations || {};
  const catalogId = configurations.catalog_id;
  if (typeof catalogId === 'string' && catalogId.trim()) {
    return catalogId.trim();
  }
  return null;
}

export function buildChannelOptionGroups(agentChannelPairs) {
  const groupsByCatalogId = new Map();

  agentChannelPairs.forEach(({ agent, channel }) => {
    if (!agent || !channel) {
      return;
    }
    if (channel.status && channel.status !== 'active') {
      return;
    }
    if (channel.type && channel.type !== 'whatsapp') {
      return;
    }

    const catalogId = extractCatalogId(channel);
    if (!catalogId) {
      return;
    }

    const existing = groupsByCatalogId.get(catalogId) || {
      catalogId,
      anchorChannelId: channel.id,
      channels: [],
      agents: [],
      agentIds: new Set(),
    };

    existing.channels.push(channel);
    if (!existing.agentIds.has(agent.id)) {
      existing.agentIds.add(agent.id);
      existing.agents.push(agent);
    }

    if (!existing.anchorChannelId) {
      existing.anchorChannelId = channel.id;
    }

    groupsByCatalogId.set(catalogId, existing);
  });

  return Array.from(groupsByCatalogId.values()).map((group) => ({
    catalogId: group.catalogId,
    anchorChannelId: group.anchorChannelId,
    channelIds: group.channels.map((channel) => channel.id),
    agentCount: group.agents.length,
    agents: group.agents,
    agentIds: Array.from(group.agentIds),
  }));
}

export function findChannelGroupByAnchorId(groups, channelId) {
  if (!channelId) {
    return null;
  }
  return (
    groups.find(
      (group) =>
        group.anchorChannelId === channelId ||
        (group.channelIds || []).includes(channelId)
    ) || null
  );
}

export function formatChannelGroupLabel(group, lineByCatalogId = {}) {
  const line = lineByCatalogId[group.catalogId] || {};
  const phoneLabel = line.phoneNumber || line.externalChannelId || group.catalogId;
  const agentLabel = `${group.agentCount} agente${group.agentCount !== 1 ? 's' : ''}`;
  return `WhatsApp ${phoneLabel} · ${agentLabel}`;
}
